import { sInputKeyValidationHelper, sIsValidPostcode, sGetFromEngagementTools } from '../../shared.min.js';

const houseRebuildCost = (() => {
	const endpoint = document.getElementById('endpoints');
	const apiKey = endpoint.dataset.apikey;

	//FLAG FOR TESTING
	const testing = false;

	//URLS
	const addressLookupURL = testing ? 'http://localhost:3000/address-lookup?postcode=' : endpoint.dataset.address;
	const propertyLookupURL = testing
		? 'http://localhost:3000/property-lookup/rebuild?udprn='
		: endpoint.dataset.property;

	//BANNER
	const banner = document.querySelector('.banner');
	const progressBar = banner.querySelector('.banner__progress-bar span');
	const progressTitle = banner.querySelector('.banner__title');
	const progressStep = banner.querySelector('.banner__progress-step-value');

	//POSTCODE SCREEN (#1)
	const inputPostcodeSection = document.getElementById('input-postcode');
	const postcode = document.getElementById('hbPostcode');
	const findPropertyButton = inputPostcodeSection.querySelector('#submit-postcode');
	const postcodeSubmit = document.getElementById('submit-postcode');

	const postCodeFieldGroup = inputPostcodeSection.querySelector('.field-group');
	const postCodeInput = postCodeFieldGroup.querySelector('input');
	const postCodeErrorMessage = postCodeFieldGroup.querySelector('.error-message');

	//ADDRESS FINDER SCREEN (#2)
	const houseDetailsSection = document.getElementById('house-details');
	const changePostcode = document.getElementById('changePostcode');
	const addressSelect = document.getElementById('address-select');
	const findAddressButton = houseDetailsSection.querySelector('#submit-address');
	const addressSubmit = document.getElementById('submit-address');

	//RESTART BUTTON
	const backToStart = document.querySelectorAll('.back-to-start');

	//RESULTS
	const displayResult = document.getElementById('house-results');
	const displayResultFail = document.getElementById('house-results-notfound');
	const resultCost = document.getElementById('rebuild-value');

	//VALIDATION
	let isValid;

	const getAddresses = (postcode, addressSelect) => {
		const addressLookupURLpostcode = `${addressLookupURL}${postcode.value}`;
		getAddressData(addressLookupURLpostcode, addressSelect);
	};

	const getAddressData = async (addressLookupURL, addressSelect) => {
		try {
			const response = await sGetFromEngagementTools(apiKey, addressLookupURL);

			if (!response.ok) {
				handleApiErrorStates(response);

				const errorMessage =
					postCodeInput.dataset.errorServer ||
					'Sorry, we are unable to find your postcode at the moment. Please try again later.';
				postCodeErrorMessage.textContent = errorMessage;
				postCodeFieldGroup.classList.add('field-group--error');
			} else {
				const addressLookupData = await response.json();

				if (addressLookupData === null || addressLookupData.length === 0) {
					//IF NO PROPERTIES RETURNED
					const errorMessage =
						postCodeInput.dataset.errorProperties ||
						"We've been unable to find any properties for that postcode. Check if the postcode is correct and try again.";
					postCodeErrorMessage.textContent = errorMessage;
					postCodeFieldGroup.classList.add('field-group--error');
				} else {
					//SUCCESS
					populateAddress(addressSelect, addressLookupData);
					postCodeFieldGroup.classList.remove('field-group--error');
				}
			}

			submitButtonState(findPropertyButton, false);
		} catch (error) {
			// console.error('Unable to fetch data:', error);
			const errorMessage =
				postCodeInput.dataset.errorServer ||
				'Sorry, we are unable to find your postcode at the moment. Please try again later.';
			postCodeErrorMessage.textContent = errorMessage;
			postCodeFieldGroup.classList.add('field-group--error');
		}
	};

	const getPropertyData = async propertyLookupURL => {
		try {
			const response = await sGetFromEngagementTools(apiKey, propertyLookupURL);

			if (!response.ok) {
				handleApiErrorStates(response);
			} else {
				const propertyLookupData = await response.json();

				if (propertyLookupData !== null) {
					const rebuildCost = propertyLookupData.value;
					showPropertyResultsSuccess(rebuildCost);
				} else {
					showPropertyResultsFail();
				}
			}

			submitButtonState(addressSubmit, false);
		} catch (error) {
			console.error(error);
			showPropertyResultsFail();
		}
	};

	const showPropertyResultsFail = () => {
		progressTitle.textContent = displayResultFail.getAttribute('data-title');
		displayResultFail.classList.remove('display-none');
		houseDetailsSection.classList.add('display-none');
		submitButtonState(findAddressButton, false);
	};

	const showPropertyResultsSuccess = rebuildCost => {
		if (!rebuildCost) return;

		//GETS THE VALUE DATA ATTRIBUTE PROVIDED BY CMS
		const defaultValue = resultCost.getAttribute('data-default-val');

		//FORMAT REBUILD COST
		const formattedRebuildCost = rebuildCost?.toLocaleString();

		//REPLACE THE {VALUE} IN THE DATA ATTRIBUTE WITH THE REBUILD COST RESULT
		const formattedResult = defaultValue.replace('{Value}', formattedRebuildCost);

		//SET THE INNERTEXT TO THE NEW STRING WITH CMS FORMATTING
		resultCost.innerText = formattedResult;

		progressTitle.textContent = displayResult.getAttribute('data-title');
		displayResult.classList.remove('display-none');
		houseDetailsSection.classList.add('display-none');
	};

	const displayProperty = selectedValue => {
		const propertyLookupURLudprn = `${propertyLookupURL}${selectedValue}`;

		getPropertyData(propertyLookupURLudprn);

		progressStep.textContent = 3;
		progressBar.classList = '';
		progressBar.classList.add('progress-3');
	};

	const handleApiErrorStates = response => {
		let errorMessage;
		switch (response.status) {
			case 400:
				errorMessage = 'Bad Request: The server could not understand the request due to invalid syntax.';
				throw new Error(errorMessage);
			case 401:
				errorMessage = 'Unauthorized: Access is denied due to invalid credentials.';
				throw new Error(errorMessage);
			case 403:
				errorMessage = 'Forbidden: You do not have the necessary permissions to access this resource.';
				throw new Error(errorMessage);
			case 500:
				errorMessage =
					"Internal Server Error: The server has encountered a situation it doesn't know how to handle.";
				throw new Error(errorMessage);
			case 404:
			default:
				errorMessage = 'Error';
				throw new Error(errorMessage);
		}
	};

	const submitButtonState = (button, disabled) => {
		if (button.getAttribute('data-originaltext') === '' || button.getAttribute('data-originaltext') === null) {
			const innerButtonText = button.textContent;
			button.setAttribute('data-originaltext', innerButtonText);
		}

		if (disabled === true) {
			button.classList.add('btn--loading');
			button.setAttribute('aria-disabled', true);
			button.setAttribute('disabled', true);
			button.textContent = 'loading';
		} else {
			button.classList.remove('btn--loading');
			button.removeAttribute('aria-disabled');
			button.removeAttribute('disabled');
			button.textContent = button.getAttribute('data-originaltext');
		}
	};

	const formValidation = (elem, type) => {
		const valTarget = document.querySelector(elem);
		const fieldset = valTarget.closest('.field-group');
		fieldset.classList.remove('field-group--error');

		const errorMessages = {
			empty: postCodeInput.dataset.errorErrorLength,
			tooShort: postCodeInput.dataset.errorErrorLength,
			tooLong: postCodeInput.dataset.errorErrorLength,
			invalidFormat: postCodeInput.dataset.errorErrorProperties,
		};

		let errorMessage = '';

		switch (type) {
			case 'postcode':
				({ isValid, errorMessage } = sIsValidPostcode(valTarget.value, errorMessages));
				break;

			case 'isSelected':
				valTarget.value === '' || valTarget.value === null ? (isValid = false) : (isValid = true);
				break;

			default:
				alert('Unknown validation type');
		}

		if (isValid) {
			fieldset.classList.remove('field-group--error');
		} else {
			if (errorMessage) fieldset.querySelector('.error-message').textContent = errorMessage;
			fieldset.classList.add('field-group--error');
		}
		return isValid;
	};

	const populateAddress = (addressSelect, postcodeData) => {
		postcodeData.forEach(option => {
			const opt = document.createElement('option');
			opt.value = option.udprn;
			opt.textContent = option.preview;
			addressSelect.appendChild(opt);
			addressSelect.selectedIndex = 0;
		});

		progressStep.textContent = 2;
		progressBar.classList = '';
		progressBar.classList.add('progress-2');
		progressTitle.textContent = houseDetailsSection.getAttribute('data-title');

		inputPostcodeSection.classList.add('display-none');
		houseDetailsSection.classList.remove('display-none');

		const pcResult = document.getElementById('pc-result');
		pcResult.textContent = postcode.value;
	};

	const reset = (postcode, displayResult, displayResultFail, step, addressSelect) => {
		progressStep.textContent = 1;
		progressBar.classList = '';
		progressBar.classList.add('progress-1');
		progressTitle.textContent = inputPostcodeSection.getAttribute('data-title');

		if (step === '2') {
			houseDetailsSection.classList.add('display-none');
		} else if (step === '3') {
			displayResult.classList.add('display-none');
		} else if (step === '4') {
			displayResultFail.classList.add('display-none');
		}

		while (addressSelect.options.length > 1) {
			addressSelect.remove(1);
		}

		inputPostcodeSection.classList.remove('display-none');
		postcode.value = '';
	};

	const setupKeyListener = () => {
		const fieldGroup = postcode.closest('.field-group');
		sInputKeyValidationHelper(postcode, 'alphaNumeric', fieldGroup);
	};

	const init = () => {
		setupKeyListener();

		postcodeSubmit.addEventListener('click', event => {
			event.preventDefault();
			submitButtonState(findPropertyButton, true);

			formValidation('#hbPostcode', 'postcode');
			if (isValid) {
				getAddresses(postcode, addressSelect);
			} else {
				submitButtonState(findPropertyButton, false);
			}
		});

		changePostcode.addEventListener('click', event => {
			event.preventDefault();
			const step = changePostcode.getAttribute('data-step');
			reset(postcode, displayResult, displayResultFail, step, addressSelect);
		});

		backToStart.forEach(btn => {
			btn.addEventListener('click', event => {
				const step = btn.getAttribute('data-step');
				event.preventDefault();
				reset(postcode, displayResult, displayResultFail, step, addressSelect);
				banner.scrollIntoView({ behavior: 'smooth' });
			});
		});

		addressSubmit.addEventListener('click', event => {
			event.preventDefault();
			submitButtonState(findAddressButton, true);

			formValidation('#address-select', 'isSelected');

			if (isValid) {
				const selectedValue = addressSelect.value;
				displayProperty(selectedValue);
			} else {
				submitButtonState(findAddressButton, false);
			}
		});

		addressSelect.addEventListener('change', () => {
			formValidation('#address-select', 'isSelected');
		});
	};

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', () => {
	houseRebuildCost.init();
});
